import {Component} from '@angular/core';

export interface VolmachtProduct {
  bankAccountNumber: string;
  name: string;
  lifeCycleStatus: string;
  authorizations: string;
}

@Component({
  selector: 'app-detail-table',
  templateUrl: './volmacht-products-table.component.html',
  styleUrls: ['../../../detail-screen/detail-screen.component.css'],
})

export class VolmachtProductsTableComponent {
  restrictedData: boolean;
  tableColumns: string[];
  tableData: VolmachtProduct[];
  emptyValuePlaceholder = '-';
  errorText: string;
  showTable: boolean;

  constructor() {
    this.tableColumns = [];
    this.tableData = [];
  }
}
